const { BaseClient } = require('../shared')

class IdpClient extends BaseClient {
  constructor(
    idpServiceUrl = process.env.IDP_SERVICE_URL, 
    idpServiceSecretName = process.env.CENTIVO_IDP_SECRET_NAME || 'idp-service-system-broker-service-key',
    axiosOptions
  ) {
    super(idpServiceUrl, idpServiceSecretName, axiosOptions)
  }

  async getSamlResponse({ destination, user, relayState, requestId }) {
    await this.createSecureAxiosInstance()

    return this.secureAxiosInstance.post(
      '/getSamlResponse',
      {
        destination,
        user,
        relayState,
        requestId,
      },
    );
  }
}

module.exports = {
  IdpClient,
};
